import type { DeepPartial } from '@luna/utils-ts';

import type { ProductSettings } from '../../types/ProductSettings';

export const productSettingsROFeatureConfig: DeepPartial<ProductSettings> = {
    showAccountInfo: true,
};
